import { useEffect } from 'react';

export const SCROLL_TO_ANCHOR_ELEMENT_APPEAR_TIMEOUT = 3000;

// If url has anchor to scroll, it will fail with SPA because it takes a time to render content,
// so this hook observes body and waits until needed element appears and scrolls to it
export function useScrollToAnchor() {
  useEffect(() => {
    if (!window.location.hash) {
      return;
    }

    const id = window.location.hash.slice(1);
    let didScroll = false;

    const observer = new MutationObserver(() => {
      const el = document.getElementById(id);

      if (el && !didScroll) {
        didScroll = true;
        el.scrollIntoView({ behavior: 'smooth' });
        observer.disconnect();
        clearTimeout(timeout);
      }
    });

    requestAnimationFrame(() => {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });

    const timeout = setTimeout(() => observer.disconnect(), SCROLL_TO_ANCHOR_ELEMENT_APPEAR_TIMEOUT);

    return () => {
      observer.disconnect();
      clearTimeout(timeout);
    };
  }, []);
}
